<section *ngIf="!forbidden" class="family-ratings" aria-labelledby="family-ratings-title">
  <h2 id="family-ratings-title" class="section-title">Valutazioni Famiglie</h2>

  <div class="grid">
    <div *ngFor="let field of averageFields">
      <label class="label" [for]="field.id">{{ field.label }}</label>
      <input
        type="text"
        [id]="field.id"
        [value]="average(field) !== null ? (average(field) | number: '1.1-1') : '-'"
        readonly
        tabindex="-1"
      />
    </div>
    <div>
      <span class="count" data-testid="family-ratings-count">
        Basato su {{ summary?.count ?? 0 }} {{ (summary?.count ?? 0) === 1 ? 'valutazione' : 'valutazioni' }}
      </span>
    </div>
  </div>

  <p *ngIf="errorMessage" class="text-danger px-3 mb-0">{{ errorMessage }}</p>

  <div class="p-3">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="fw-bold">
          Storico Valutazioni Famiglie
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table class="w-100 table table-striped">
        <thead>
          <tr>
            <th>Data</th>
            <th>Servizio</th>
            <th>Puntualità</th>
            <th>Empatia</th>
            <th>Educazione</th>
            <th>Comunicazione</th>
            <th>Famiglia</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of ratings">
            <td class="fw-normal">{{ record.updatedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
            <td>{{ record.serviceScore }}</td>
            <td>{{ record.punctuality }}</td>
            <td>{{ record.empathy }}</td>
            <td>{{ record.education }}</td>
            <td>{{ record.communication }}</td>
            <td>
              <a
                *ngIf="record.requestId; else noLink"
                [href]="'/request-detail/' + record.requestId"
                target="_blank"
                rel="noopener"
                [title]="'Apri la richiesta #' + record.requestId"
              >{{ record.familyName || ('Richiesta #' + record.requestId) }}</a>
              <ng-template #noLink>{{ record.familyName }}</ng-template>
            </td>
          </tr>
          <tr *ngIf="!loading && ratings.length === 0">
            <td colspan="7" class="text-center">Nessuna valutazione dalle famiglie</td>
          </tr>
          <tr *ngIf="loading">
            <td colspan="7" class="text-center">Caricamento...</td>
          </tr>
        </tbody>
      </table>
    </mat-expansion-panel>
  </div>
</section>
